module.exports = __webpack_public_path__ + "static/media/ph.667b70e3.svg";